import { _getScripsInfo } from "../../controllers";
import { SCRIPINFO } from "../actionTypes";

export const getScripInfo = (arrScrips) => async (dispatch) => {
    try {
        const objResp = await _getScripsInfo(arrScrips);
        if (objResp?.status) {
            dispatch(scripInfoSuccess(objResp.data?.objScripsResp.result));
            // Ajitesh 19-06-2024 return data via promise
            return Promise.resolve(objResp.data?.objScripsResp.result);
        } else {
            //Prachi T :BT-107377 - 17-11-2023 ScripInnfo recommendations - Start
            dispatch(scripInfoFailure([]));
        }
    } catch (error) {
        console.error(error);
        dispatch(scripInfoFailure(error?.response?.data));
        //Prachi T :BT-107377 - 17-11-2023 ScripInnfo recommendations - Start
    }
};


export const scripInfoSuccess = (payload) => {
    // Need to make data binding here and add action type in reducer
    return { type: SCRIPINFO.GET_SCRIP_INFO_SUCCESS, payload };
};

export const scripInfoFailure = (payload) => {
    return { type: SCRIPINFO.GET_SCRIP_INFO_FAILURE, payload };
};